import { classed } from "@/components/classed.config";

const Center = classed.div("flex items-center justify-center");

export default Center;
